import { render, staticRenderFns } from "./Scene19.vue?vue&type=template&id=1ac87e8b&scoped=true"
import script from "./Scene19.vue?vue&type=script&lang=js"
export * from "./Scene19.vue?vue&type=script&lang=js"
import style0 from "./Scene19.vue?vue&type=style&index=0&id=1ac87e8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac87e8b",
  null
  
)

export default component.exports